import { useQueryWithUserId } from '@northladder/services';

import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';

/**
 * This is to track the users registration details from he backend.
 */
const REGISTRATION_DETAILS_KEY = 'registration-details-key';

interface IUseRegistrationDetailsQueryOptions {
  enabled?: boolean;
  token: string;
}

/**
 * This hook fetches a list of device dimensions details and tokens and urls to
 * which images would later be uploaded.
 */
export const useRegistrationDetailsQuery = ({
  enabled = true,
  token,
}: IUseRegistrationDetailsQueryOptions) => {
  const { data, isError, error, isPending, isFetching, refetch } =
    useQueryWithUserId({
      queryKey: [REGISTRATION_DETAILS_KEY, token],
      queryFn: () => USER_REGISTRATION_API.fetchUserRegistrationDetails(token),
      retry: false,
      enabled: !!token && enabled,
      refetchOnWindowFocus: false,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
